// This directive shows a graph of a BoxCaster's CPU usage.
angular.module('app.directives').directive('appBoxcasterCpuGraph', $location =>
    ({
        require: '^^appBoxcasterGraph',
        restrict: 'E',
        scope: {
            statsData: '=',
            numCores: '='
        },
        controller($scope) {
            $scope.data = [];
            $scope.options = {
                renderer: 'area',
                height: 40,
                min: 0,
                max: 100
            };
            return $scope.series = [{
                data: $scope.data,
                color: 'rgb(255,160,160)'
            }];
        },
        link(scope, element, attrs, appBoxcasterGraph) {
            scope.$watch('statsData', function(newval, oldval) {
                if (newval != null) {
                    const times = _.keys(newval[_.keys(newval)[0]]);
                    times.sort((a, b) => a - b);

                    // Find CPU-related keys
                    const cpuKeys = _.filter(_.keys(newval), k => k.match(/^cpu\./));

                    // Rebuild data with sums
                    scope.data.length = 0;
                    _.each(times, t => scope.data.push({ x: parseInt(t), y: appBoxcasterGraph.statsForTime(cpuKeys, t) / scope.numCores }));
                    return scope.data.sort((a, b) => a.x - b.x);
                }
            });
            return appBoxcasterGraph.registerGraphWidthCallback(newWidth =>
                scope.$apply(() => scope.options.width = newWidth)
            );
        },
        template: "<app-rickshaw rickshaw-options=\"options\" rickshaw-series=\"series\"></app-rickshaw>"
    }));


// WEBPACK FOOTER //
// ./directives/boxcaster_cpu_graph.js